import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=ec1ecf2e&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec1ecf2e')) {
      api.createRecord('ec1ecf2e', component.options)
    } else {
      api.reload('ec1ecf2e', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=ec1ecf2e&", function () {
      api.rerender('ec1ecf2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-48JmpZ7RNFEFK/JS/pricehelp.vue"
export default component.exports